<template>
	<div class="space">
		<div class="tab-list">
			<div class="mid">
				<span>个人空间</span>
				<upload-link class="upload fr" :show-file-list="false" accept="*" :fileLimit="10" @changeUpload="changeUpload" ref="uploadSc">
					<template slot="body">
						<el-button class="fr" type="primary" icon="el-icon-upload2" size="small">我的素材</el-button>
					</template>
				</upload-link>
			</div>
		</div>
		<div class="content">
			<div class="seaech-tab">
				<div class="tab-list">
					<div class="mid">
						<span @click="changeType(i.code)" :class="activeCode===i.code ? 'active':'' " v-for="i in typeList" :key="i.code">{{i.name}}</span>
					</div>
				</div>
			</div>
			<div class="space-table">
				<el-button class="del fr" type="primary" size="small" @click="showDel">批量删除</el-button>
				<!-- 表格 -->
				<el-table element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.9)" v-loading="isTableLoading" :data="dataList" stripe style="width: 100%" :header-cell-style="{background:'#EFEFEF'}" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="attachName" label="文件名称" width="170"></el-table-column>
					<el-table-column prop="name" label="类型" width="120">
						<template slot-scope="scope">
							<i v-if="scope.row.attachType" class="big-icon" :class="mapFileIcon(scope.row.attachType)"></i>
						</template>
					</el-table-column>
					<el-table-column prop="createTime" label="上传时间"></el-table-column>
					<el-table-column prop="attachSize" label="文件大小">
						<template slot-scope="scope">{{scope.row.attachSize ? scope.row.attachSize + " kb" :""}}</template>
					</el-table-column>
					<el-table-column prop="name" label="操作">
						<template slot-scope="scope">
							<el-button type="text" @click="lookFile(scope.row.attachUrl)">预览</el-button>
							<el-divider direction="vertical"></el-divider>
							<el-button type="text" v-if="scope.row.createBy==userInfo.userId" class="ml del-btn" @click="delPop(scope.row)">删除</el-button>
							<el-divider direction="vertical"></el-divider>
							<el-button type="text" @click="downloadFile(scope.row.attachUrl,scope.row.attachName)">下载</el-button>
						</template>
					</el-table-column>
				</el-table>
				<pagination :pageObj="pageObj" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pagination>
			</div>
		</div>
		<!-- 删除的对话框 -->
		<popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>
	</div>
</template>

<script>
import PopupDel from "@/components/PopupDel.vue";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState } from "vuex";
import UploadLink from "@/components/upload/UploadLink.vue";
import { mapFileIcon, lookFile, downloadUrlFile } from "@/utils/index.js";
import Pagination from "@/components/Pagination.vue";
export default {
	components: {
		Pagination,
		PopupDel,
		UploadLink
	},
	computed: {
		...mapState(["userInfo", "resOptions"])
	},
	data() {
		return {
			delVisible: false,
			btnLoading: false,
			isTableLoading: false,
			delAttachs: [],
			typeList: [
				{ code: "", name: "全部" },
				{ code: "doc", name: "文档" },
				{ code: "audio", name: "音频" },
				{ code: "video", name: "视频" },
				{ code: "image", name: "图片" },
				{ code: "other", name: "其它格式" }
			],
			activeCode: "",
			dataList: [],
			form: {},

			rules: {},
			pageObj: {
				current: 1,
				total: 0,
				size: 10,
				sizeList: [5, 10, 15, 20]
			},
			form: {
				attachDTOS: [{}],
				operatorId: ""
			}
		};
	},
	created() {
		this.init();
	},
	methods: {
		mapFileIcon,
		lookFile,
		init() {
			this.selectData();
		},
		async selectData() {
			this.isTableLoading = true;
			let { total, records } = await postJson("/planning/getPersonalSpace", {
				userId: this.userInfo.userId,
				pageNum: this.pageObj.current,
				pageSize: this.pageObj.size,
				attachType: this.activeCode
			});
			records.forEach(i => {
				i.attachUrl = i.attachUrl || "";
				i.attachType = i.attachUrl
					? i.attachUrl.substring(
							i.attachUrl.lastIndexOf(".") + 1,
							i.attachUrl.length
					  )
					: "";
				i.attachName =
					i.attachName ||
					i.attachUrl.substring(
						i.attachUrl.lastIndexOf("/") + 1,
						i.attachUrl.length
					);
			});
			this.pageObj.total = total;
			this.dataList = records;
			this.isTableLoading = false;
		},
		changeUpload(fileList) {
			this.form.attachDTOS = fileList;
			this.form.operatorId = this.userInfo.userId;
			this.$refs.uploadSc.clearFiles();
			postJson("/planning/savePersonalAttach", this.form).then(res => {
				this.init();
			});
		},
		delPop(row) {
			this.delAttachs = [
				{
					classify: row.classify,
					id: row.id
				}
			];
			this.delVisible = true;
		},
		downloadFile(url, name) {
			//确认下载完成 后 进行下载记录保存
			downloadUrlFile(url, name);
		},
		showDel() {
			if (this.delAttachs.length === 0) {
				this.$message.error("请先选择要删除的文件！");
			} else {
				this.delVisible = true;
			}
		},
		// 删除弹框 关闭
		async closePopupDel(status) {
			try {
				if (status) {
					await postJson("/planning/batchDelete", {
						attachs: this.delAttachs,
						classify: "",
						id: ""
					});
					this.delAttachs = [];
					this.$message({
						message: "删除成功",
						type: "success",
						duration: 2000,
						offset: 150
					});
					this.selectData();
					this.delVisible = false;
				} else {
					this.delVisible = false;
				}
			} catch (err) {
				console.log("err", err);
			}
		},
		changeType(code) {
			this.activeCode = code;
			this.pageObj.current = 1;
			this.selectData();
		},
		handleSelectionChange(i) {
			this.delAttachs = i;
		},
		//分页
		handleSizeChange(pageSize) {
			this.pageObj.current = 1;
			this.pageObj.size = pageSize;
			this.selectData();
		},
		handleCurrentChange(curPage) {
			this.pageObj.current = curPage;
			this.selectData();
		}
	},
	watch: {}
};
</script>

<style lang="less" scoped>
.space {
	.tab-list {
		background-color: #fff;
		padding: 20px 0px;
		border-bottom: 2px solid #eee;
		span {
			font-size: 17px;
			padding: 6px 8px;
			border-radius: 8px;
			margin-left: 100px;
			color: @color;
		}
		.upload {
			margin-right: 70px;
			margin-top: -5px;
		}
	}
	.content {
		background-color: #fff;
		margin-top: 15px;
		padding: 10px 0px;
		.seaech-tab {
			.tab-list {
				padding: 13px 0px;
				border-bottom: 3px solid #eee;
				span {
					font-size: 14.5px;
					cursor: pointer;
					padding: 6px 8px;
					border-radius: 8px;
					margin: 0px 5%;
					color: rgb(54, 53, 53);
				}
				span:hover {
					color: @color;
					//background-color: @hover-bg;
				}
				.active {
					color: @color;
					//background-color: @hover-bg;
				}
			}
		}
		.space-table {
			padding-bottom: 30px;
			padding: 0px 15px;
			// border: 1px solid #000;
			.del {
				margin: 8px;
				margin-right: 60px;
			}
			.big-icon {
				font-size: 25px;
				color: @color;
				// font-weight: 700;
			}
			.del-btn {
				color: @hong;
			}
		}
	}
}
</style>
